export default __webpack_public_path__ + "static/media/Frame_183.485dbf79.jpg";